/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} P1portal_Group_HomeInputs */



/**
* | output |
* | --- |
* | "Home" |
*
* @param {P1portal_Group_HomeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const p1portal_group_home = /** @type {((inputs?: P1portal_Group_HomeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<P1portal_Group_HomeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Home")
});